function getPrefersReducedMotion() {
  return typeof window !== 'undefined' ? window.matchMedia('(prefers-reduced-motion)').matches : false;
}

export default getPrefersReducedMotion;
